import { render } from "./ChatNow.vue?vue&type=template&id=035c254a&scoped=true"
import script from "./ChatNow.vue?vue&type=script&lang=js"
export * from "./ChatNow.vue?vue&type=script&lang=js"

import "./ChatNow.vue?vue&type=style&index=0&id=035c254a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035c254a"]])

export default __exports__